import { render, staticRenderFns } from "./miniMulticard.vue?vue&type=template&id=3f4b1ec8"
import script from "./miniMulticard.vue?vue&type=script&lang=js"
export * from "./miniMulticard.vue?vue&type=script&lang=js"
import style0 from "./miniMulticard.vue?vue&type=style&index=0&id=3f4b1ec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports